import { use, useEffect, useState } from 'react';
import { onAuthStateChanged, type User } from 'firebase/auth';
import { AuthContext } from '@/lib/context';

interface State {
    isUserLoading: boolean;
    user?: User;
}

export default function useUser() {
    const auth = use(AuthContext);
    const [state, setState] = useState<State>({isUserLoading: true});
    if (!auth) {
        throw new Error(`useUser must be within AuthContext`);
    }

    useEffect(() => {
        const listener = onAuthStateChanged(auth, user => {
            setState({isUserLoading: false, user});
        });
        return listener;
    }, []);

    return state;
}